import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-move-steps',
  templateUrl: './move-steps.component.html',
  styleUrls: ['./move-steps.component.scss']
})
export class MoveStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
